import { ItemSeparatorItem } from 'common/ui/ItemSeparator';
import { formatDateFromNow } from 'utils/datetime';
import { SourcedCandidateByCandidateProfile } from 'modules/candidate-profile/types/SourcedCandidateByCandidateProfile';
import { SourcingCandidateStatusIcon } from 'modules/sourcing-shared/components/SourcingCandidateStatusIcon';

export const getCandidateProfileInvitationSeparatorItems = (
  candidate: SourcedCandidateByCandidateProfile | null
): ItemSeparatorItem[] => {
  if (!candidate) {
    return [];
  }

  const items: ItemSeparatorItem[] = [];

  const candidateBatch = candidate.candidateBatch;
  const jobDescription = candidateBatch?.jobDescriptionParsed;

  if (jobDescription?.employerName) {
    items.push(jobDescription.employerName);
  }

  if (candidateBatch?.atsJobId) {
    items.push(`Job ID ${candidateBatch.atsJobId}`);
  }

  if (candidateBatch?.createdAt) {
    items.push(`Applied ${formatDateFromNow(candidateBatch.createdAt)}`);
  }

  if (candidate.status && candidate.id && candidateBatch?.id) {
    items.push(
      <SourcingCandidateStatusIcon
        status={candidate.status}
        sourcedCandidateId={candidate.id}
        candidateBatchId={candidateBatch?.id}
      />
    );
  }

  return items;
};
